<rt-dialog-body layout layout-justify-center>
  <div layout-vertical layout-align-items-center margin-small>
    <div layout-centered margin-tb-medium>
      <img [src]="imageSrc" [style.height]="imageHeight" alt="" />
    </div>
    <div margin-tb layout-vertical layout-align-items-center>
      <rt-heading variant="heading large-xx dark">
        {{ message }}
      </rt-heading>
      <rt-heading [variant]="descriptionVariant">
        {{ description }}
      </rt-heading>
    </div>
    <div layout-full-width layout-centered>
      @for (button of buttons; track trackByValue($index, button); let isLast = $last) {
        <rt-button
          [variant]="$any(button.variant)"
          [attr.margin-right-small]="!isLast"
          (click)="close(button)"
        >
          @if (button.icon) {
            <rt-icon [name]="button.icon"></rt-icon>
          }
          <span>{{ button.text }}</span>
        </rt-button>
      }
    </div>
  </div>
</rt-dialog-body>
